import React, {useContext, useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {Context} from "../index";
import AuthService from "../service/AuthService";

const ResetPass = () => {
    const {userStore} = useContext(Context)
    const [isClosed, setIsClosed] = useState([true, true]);
    const [password, setPassword] = useState(["", ""]);
    const [isHashValid, setIsHashValid] = useState(false);
    const [email, setEmail] = useState("");

    const dis = password[0] === password[1] && password[0].length >= 3;
    const hash = useParams().hash;

    useEffect(() => {
        userStore.checkHash(hash)
            .then(res => {setIsHashValid(true); setEmail(res.data.email)})
            .catch(e => alert(`ОКАК: ${e?.response?.data?.message || e}`));
    }, [])

    async function changePassword(e) {
        e.preventDefault();
        try {
            const res = await AuthService.resetPassword(password[0], email);
            if (res.data.success) alert("Пароль успешно изменен")
        } catch (e) {
            alert(`ОКАК: ${e?.response?.data?.message || e}`)
        }
    }

    return (
        <div className="container">
            <div className="block-auth">
                {isHashValid ? <form id="auth" onSubmit={changePassword}>
                    <p id={`h-log`} style={{fontSize: "24px"}}>Восстановление пароля</p>
                    <div className="input-cont">
                        <input required type={isClosed[0] ? "password" : "text"} minLength="3" maxLength="32" placeholder="Введите новый пароль" value={password[0]} onChange={e => setPassword(prev => [e.target.value, prev[1]])}/><i className={!isClosed[0] ? "icon-eye" : "icon-eyeoff"} onClick={() => setIsClosed(prev => [!prev[0], prev[1]])}></i>
                    </div>
                    <div className="input-cont">
                        <input required type={isClosed[1] ? "password" : "text"} minLength="3" maxLength="32" placeholder="Повторите пароль" value={password[1]} onChange={e => setPassword(prev => [prev[0], e.target.value])}/><i className={!isClosed[1] ? "icon-eye" : "icon-eyeoff"} onClick={() => setIsClosed(prev => [prev[0], !prev[1]])}></i>
                    </div>
                    <button disabled={!dis} id="b-log" type="submit">Поменять пароль</button>
                </form> : <p style={{fontSize: "20px"}}>Ссылка некорректна</p>}
            </div>
        </div>
    );
};

export default ResetPass;